<div class="wrapper">
  <div class="sectionSticky">
    <app-banner></app-banner>
  </div>

  <div class="sectionSticky">
    <section class="newUsedEquipments">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 data-aos="fade-up">EQUIPOS PARA TUS PROYECTOS</h2>
            <p data-aos="fade-up">
              Encuentra equipos nuevos y usados, con el respaldo de Caterpillar. Soluciones eficientes, siempre
              disponibles y respaldadas con el soporte que tu proyecto necesita.
            </p>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="contentButtonsTabs">
              <div class="contentSwitchButtons">
                <button (click)="changeTabOption(0)" [ngClass]="{ active: tabOption() === 0 }">NUEVOS</button>
                <button (click)="changeTabOption(1)" [ngClass]="{ active: tabOption() === 1 }">USADOS</button>
              </div>
              <div class="buttonsCarouselUsedEquipments">
                @if(countEquipmentCurrent() > limitEquipments()) {
                <button (click)="clickPrev()" class="prev" aria-label="Botón previo"></button>
                <button (click)="clickNext()" class="next" aria-label="Botón siguiente"></button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container containerCarousel">
        <div class="row">
          <div class="col-lg-12">
            @switch (tabOption()) { @case (0) {
            <div class="carouselNewTab">
              <app-new-carousel
                (countEquipment)="getCountEquipment($event)"
                [nextPrev]="carouselAction()"
              ></app-new-carousel>
            </div>
            <a routerLink="/productos" class="btnTracsa btnTransparentBlack">VER MAQUINARIA</a>
            } @case (1) {
            <div class="carouselUsedTab">
              <app-used-carousel
                (countEquipment)="getCountEquipment($event)"
                [nextPrev]="carouselAction()"
              ></app-used-carousel>
            </div>
            <a routerLink="/equipo-usado/categorias" class="btnTracsa btnTransparentBlack mt-4">VER MAQUINARIA</a>
            } }
          </div>
        </div>
      </div>
    </section>
    <app-technologies></app-technologies>
    <section class="usedEquipments">
      <div class="container containerText">
        <div class="row">
          <div class="col-lg-6">
            <h2>EQUIPOS RECOMENDADOS</h2>
          </div>
          <div class="col-lg-6">
            <div class="buttonsCarouselUsedEquipments">
              @if (relatedEquipments().length > 4) {
              <button (click)="carouselEquipments.slickPrev()" class="prev" aria-label="Botón previo"></button>
              <button (click)="carouselEquipments.slickNext()" class="next" aria-label="Botón siguiente"></button>
              }
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <ngx-slick-carousel
              class="carousel carouselUsedEquipments"
              #slickModal="slick-carousel"
              [config]="equipmentsConfig"
              #carouselEquipments
            >
              @for (equipment of relatedEquipments(); track $index) {
              <div ngxSlickItem class="slide" data-aos="fade-up">
                <app-card-list [show]="false" [card]="equipment" />
              </div>
              }
            </ngx-slick-carousel>
          </div>
        </div>
      </div>
    </section>
    <app-about></app-about>
  </div>
</div>
